import { render, staticRenderFns } from "./CourseAssessment.vue?vue&type=template&id=786ad165"
import script from "./CourseAssessment.vue?vue&type=script&lang=js"
export * from "./CourseAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports